import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import { HeroUIProvider } from "@heroui/react";

import "../index.css";
import { MemoryRouter } from "react-router-dom";
import "./i18n";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(
    <HeroUIProvider>
      <MemoryRouter>
        <App />
      </MemoryRouter>
    </HeroUIProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./app/App", () => {
    const Applicaiton = require("./app/App").default;
    root?.render(Applicaiton);
  });
}
